import { Stack } from '@mui/material';
import { Job } from '../../common/apis/dtos';
import StatusBar from './StatusBar';
import { ShipmentRoute } from "./ShipmentRoute";
import { TrackingSummary } from './TrackingSummary';

declare interface TrackingProps {
  shipment: Job;
  isMobileScreen: boolean;
}

export const Tracking = ({shipment, isMobileScreen}: TrackingProps) => {
  return (
    <Stack spacing={2} padding={1} className={isMobileScreen ? 'mobile' : ''} data-testid="shipment-tracking-tab">
      <StatusBar status={shipment.status} isMobileScreen={isMobileScreen} />
      <TrackingSummary shipment={shipment} isMobileScreen={isMobileScreen} />
      <ShipmentRoute shipment={shipment} isMobileScreen={isMobileScreen} />
    </Stack>
  )
}
